import { EditIcon } from "@chakra-ui/icons";
import { Box, Button, Container, Flex, Spacer, Text, Image, Heading, Divider, SimpleGrid, Grid, GridItem, ButtonGroup, IconButton } from "@chakra-ui/react";
import { ReactElement, useEffect, useState } from "react";
import { useNavigate, useParams } from "react-router-dom";
import LoadingScreen from "components/loading-screen";
import Layout from "scenes/layouts";
import ShortenLinkService from "../../services/shorten/shortenlink-service";
import Clipboard from "components/clipboard";
import AppConsts from "../../libs/appconst";
import Number from "components/number-format";

const ShortenDetail = (): ReactElement => {
    const navigate = useNavigate();
    const { shortLinkId } = useParams();
    const [isLoading, setLoading] = useState<boolean>(true);
    const [shortLink, setShortLink] = useState<any>(null);

    useEffect(() => {
        setLoading(true);
        ShortenLinkService.Get(shortLinkId).then((res: any) => {
            setShortLink(res.result);
        }).finally(() => {
            setLoading(false);
        });
    }, []);

    if (isLoading)
        return (<LoadingScreen />)

    return (
        <Layout>
            <Container maxWidth={"8xl"} pt={10}>
                <Box>
                    <Flex>
                        <Text fontSize={'3xl'} fontWeight={"bold"}>Short Url {shortLink.name}</Text>
                        <Spacer />
                        <Button ml={2} variant={"outline"} onClick={() => { navigate(`/shorturls/${shortLinkId}/edit`) }}>Edit Url</Button>
                    </Flex>
                    <Box rounded={'lg'} borderWidth={1} p={8}>
                        <Box>
                            <Heading fontSize={'md'} fontWeight={'bold'}>Informasi</Heading>
                            <SimpleGrid columns={{ base: 1, md: 2 }}>
                                <Box py={4} flex={1}>
                                    <Text fontSize={'sm'} color={'gray.500'}>Nama</Text>
                                    <Text fontSize={'sm'} fontWeight={'bold'}>{shortLink.name || '-'}</Text>
                                </Box>
                                <Box py={4} flex={1}>
                                    <Text fontSize={'sm'} color={'gray.500'}>Back Half</Text>
                                    <Text fontSize={'sm'} fontWeight={'bold'}>{shortLink.backHalf || '-'}</Text>
                                </Box>
                            </SimpleGrid>
                            <Box py={0} flex={1}>
                                <Text fontSize={'sm'}>Long Url (Destinasi)</Text>
                                <Clipboard value={shortLink.longUrl || '-'}></Clipboard>
                            </Box>
                        </Box>

                        <Divider my={5} />

                        <Box>
                            <Box pt={0} pb={4} flex={1}>
                                <Text fontSize={'sm'} color={'gray.500'}>Back Half</Text>
                                <Text fontSize={'sm'} fontWeight={'bold'}>{shortLink.backHalf || '-'}</Text>
                            </Box>
                            <Box py={0} flex={1}>
                                <Text fontSize={'sm'}>Short Url</Text>
                                <Clipboard value={AppConsts.API_SHORTENURL_URL + "/" + shortLink.backHalf || '-'}></Clipboard>
                            </Box>
                        </Box>

                        <Divider my={5} />

                        <Box>
                            <SimpleGrid columns={{ base: 1, md: 2 }}>
                                <Box pt={0} pb={4} flex={1}>
                                    <Text fontSize={'sm'} color={'gray.500'}>Status</Text>
                                    <Text fontSize={'sm'} fontWeight={'bold'} color={shortLink.status == 10 ? "green.600" : "red.500"}> {shortLink.status == 10 ? "Aktif" : "Tidak Aktif" || '-'}</Text>
                                </Box>
                                <Box py={0} flex={1}>
                                    <Text fontSize={'sm'}>Visited</Text>
                                    <Number displayType={'text'} prefix={''} thousandSeparator={true} value={shortLink.visited} />
                                </Box>
                            </SimpleGrid>
                        </Box>

                        <Divider my={5} />

                        <Box>
                            <ButtonGroup gap={2}>
                                <Button onClick={() => navigate(`/shorturls/${shortLinkId}/edit`)}>Edit</Button>
                                <Button variant={'outline'} onClick={() => { navigate('/shorturls') }}>Kembali</Button>
                            </ButtonGroup>
                        </Box>
                    </Box>
                </Box>
            </Container>
        </Layout >
    );
};

export default ShortenDetail;